export default "__VITE_ASSET__BuC3R40P__"